export const availableCourierCollectionGuard = 'GET /couriers/available';
